import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Button, Container } from "@mui/material";

import { useAppSelector } from "../../../app/hooks";
import { useGetCurrentUserQuery } from "../../../app/user/api";
import logo4Img from "../../../assets/svg/aidentis_4.svg";
import logo4ImgWhite from "../../../assets/svg/aidentis_4_white.svg";
import AddLeftCasesModal from "../../../components/AddLeftCasesModal";
import CreatePromocodeModal from "../../../components/CreatePromocodeModal";
import LangSwitcher from "../../../components/LangSwitcher";
import ThemeSwitcher from "../../../components/ThemeSwitcher";
import { useThemeContext } from "../../../context/ThemeContext";
import PATH from "../../../helpers/PATH";

import { AppHeaderWrapper } from "./styles";

interface AppHeaderProps {
  isPanoramicResults?: boolean;
}

const AppHeader: React.FC<AppHeaderProps> = ({
  isPanoramicResults = false,
}) => {
  const { t } = useTranslation();
  const { mode } = useThemeContext();
  const { token, user } = useAppSelector((state) => state.userSlice);
  const navigate = useNavigate();
  const [isPromocodeModalOpen, setIsPromocodeModalOpen] = useState(false);
  const [isAddLeftCasesModalOpen, setIsAddLeftCasesModalOpen] = useState(false);

  // Fetch current user data when token is available
  useGetCurrentUserQuery(null, { skip: !token });

  // Add a fallback to show "My Profile" if user data is not yet loaded
  const displayName = user?.firstName || t("app:myProfile");

  // Check if user is admin
  const isAdmin =
    user?.roles?.some((role) => role.name === "ROLE_ADMIN") || false;

  return (
    <AppHeaderWrapper isPanoramicResults={isPanoramicResults} mode={mode}>
      <Container
        sx={{
          padding: `${isPanoramicResults ? "0 130px" : "0"} !important`,
          maxWidth: `${isPanoramicResults ? "100%" : "1468px"} !important`,
        }}
      >
        <div className="header">
          <Link className="logo" to={token ? PATH.APP_CASES : PATH.HOME}>
            <img
              alt="AIDentis"
              src={mode === "dark" ? logo4ImgWhite : logo4Img}
            />
          </Link>
          <menu>
            <li>
              <ThemeSwitcher />
            </li>
            {token ? (
              <>
                {isAdmin && (
                  <>
                    <li>
                      <Button
                        sx={{ color: mode === "dark" ? "#F0F0F0" : "#1A509B" }}
                        onClick={() => setIsPromocodeModalOpen(true)}
                      >
                        Создать промокод
                      </Button>
                    </li>
                    <li>
                      <Button
                        sx={{ color: mode === "dark" ? "#F0F0F0" : "#1A509B" }}
                        onClick={() => setIsAddLeftCasesModalOpen(true)}
                      >
                        Добавить кейсы
                      </Button>
                    </li>
                  </>
                )}
                <li>
                  <Button
                    sx={{ color: mode === "dark" ? "#F0F0F0" : "#1A509B" }}
                    onClick={() => navigate(PATH.APP_PROFILE)}
                  >
                    {displayName}
                  </Button>
                </li>
              </>
            ) : null}
            <li>
              <LangSwitcher />
            </li>
          </menu>
        </div>
      </Container>
      <CreatePromocodeModal
        open={isPromocodeModalOpen}
        onClose={() => setIsPromocodeModalOpen(false)}
      />
      <AddLeftCasesModal
        open={isAddLeftCasesModalOpen}
        onClose={() => setIsAddLeftCasesModalOpen(false)}
      />
    </AppHeaderWrapper>
  );
};

export default AppHeader;
